/**
 * Aurore — aurore-collection.js  v3
 * Updates: variant swatch interaction, fixed load more, filter sync, Judgeme
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────
     HELPERS
  ───────────────────────────────────── */
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ─────────────────────────────────────
     DESKTOP FILTER SIDEBAR TOGGLE
  ───────────────────────────────────── */
  var collectionLayout = qs('#aur-collection-layout');
  var desktopFilterToggle = qs('#aur-desktop-filter-toggle');
  var desktopFilterSidebar = qs('#aur-filter-sidebar');
  var DESKTOP_FILTER_STORAGE_KEY = 'auroreCollectionFiltersExpanded';

  function setDesktopFiltersExpanded(expanded, persist) {
    if (!collectionLayout || !desktopFilterToggle || !desktopFilterSidebar) return;
    collectionLayout.classList.toggle('aur-filters-collapsed', !expanded);
    desktopFilterToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    desktopFilterToggle.textContent = expanded ? 'Hide filter' : 'Show filter';
    desktopFilterSidebar.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    if (persist && window.localStorage) {
      window.localStorage.setItem(DESKTOP_FILTER_STORAGE_KEY, expanded ? 'true' : 'false');
    }
  }

  if (desktopFilterToggle && collectionLayout) {
    var storedDesktopFilterState = window.localStorage ? window.localStorage.getItem(DESKTOP_FILTER_STORAGE_KEY) : null;
    setDesktopFiltersExpanded(storedDesktopFilterState === 'true', false);
    desktopFilterToggle.addEventListener('click', function() {
      setDesktopFiltersExpanded(collectionLayout.classList.contains('aur-filters-collapsed'), true);
    });
  }

  /* Build a clean URL preserving sort_by but replacing filter params */
  function buildFilterURL(activeFilters) {
    var params = new URLSearchParams(window.location.search);

    var controlledTagValues = qsa('.aur-sidebar-option[data-filter-group="metal"], .aur-sidebar-option[data-filter-group="stone"], .aur-sidebar-option[data-filter-group="style"], .aur-sidebar-option[data-filter-group="availability"]').map(function(option) {
      return option.dataset.filterValue;
    });
    var keptTags = params.getAll('filter.p.tag').filter(function(tagValue) {
      return controlledTagValues.indexOf(tagValue) === -1;
    });
    params.delete('filter.p.tag');
    keptTags.forEach(function(tagValue) {
      params.append('filter.p.tag', tagValue);
    });

    activeFilters.forEach(function(f) {
      if (f.group === 'price') {
        if (f.value === 'under-500')  { params.set('filter.v.price.lte', '500'); }
        if (f.value === '500-1000')   { params.set('filter.v.price.gte', '500'); params.set('filter.v.price.lte', '1000'); }
        if (f.value === '1000-plus')  { params.set('filter.v.price.gte', '1000'); }
        if (f.value === 'under-300')  { params.set('filter.v.price.lte', '300'); }
        if (f.value === '300-500')    { params.set('filter.v.price.gte', '300'); params.set('filter.v.price.lte', '500'); }
      } else if (f.group === 'metal' || f.group === 'stone' || f.group === 'style') {
        params.append('filter.p.tag', f.value);
      } else if (f.group === 'availability') {
        params.append('filter.p.tag', f.value);
      }
    });

    params.delete('page');
    var search = params.toString();
    return window.location.pathname + (search ? '?' + search : '');
  }

  function getActiveFilters() {
    var filters = [];
    qsa('.aur-sidebar-option.active:not([data-filter-value="all"])').forEach(function(option) {
      var group = option.dataset.filterGroup;
      var value = option.dataset.filterValue;
      if (group && group !== 'category' && value) {
        filters.push({ group: group, value: value });
      }
    });
    return filters;
  }

  /* ─────────────────────────────────────
     SYNC UI FROM URL ON LOAD
  ───────────────────────────────────── */
  function syncUIFromURL() {
    var params = new URLSearchParams(window.location.search);

    var priceGte = params.get('filter.v.price.gte');
    var priceLte = params.get('filter.v.price.lte');
    var priceValue = null;
    if (!priceGte && priceLte === '300') priceValue = 'under-300';
    if (!priceGte && priceLte === '500') priceValue = 'under-500';
    if (priceGte === '300' && priceLte === '500') priceValue = '300-500';
    if (priceGte === '500' && priceLte === '1000') priceValue = '500-1000';
    if (priceGte === '1000' && !priceLte) priceValue = '1000-plus';

    if (priceValue) {
      var priceChip = qs('.aur-filter-chip[data-filter-group="price"][data-filter-value="' + priceValue + '"]');
      if (priceChip) priceChip.classList.add('active');
      var priceSide = qs('.aur-sidebar-option[data-filter-group="price"][data-filter-value="' + priceValue + '"]');
      if (priceSide) priceSide.classList.add('active');
    }

    var tags = params.getAll('filter.p.tag');
    qsa('.aur-filter-chip[data-filter-value], .aur-sidebar-option[data-filter-value]').forEach(function(option) {
      var isTag = option.dataset.filterParam
        ? option.dataset.filterParam === 'filter.p.tag'
        : ['style', 'metal', 'stone', 'availability'].includes(option.dataset.filterGroup);
      if (isTag && tags.includes(option.dataset.filterValue)) option.classList.add('active');
    });

    updateActiveTagsUI();
  }

  /* ─────────────────────────────────────
     FILTER CHIP TOGGLE
  ───────────────────────────────────── */
  qsa('.aur-filter-chip').forEach(function(chip) {
    chip.addEventListener('click', function() {
      var group = chip.dataset.filterGroup;
      var value = chip.dataset.filterValue;
      if (group === 'category') return;

      if (value === 'all') {
        qsa('.aur-filter-chip[data-filter-group="' + group + '"]').forEach(function(c) { c.classList.remove('active'); });
        chip.classList.add('active');
      } else {
        var allChip = qs('.aur-filter-chip[data-filter-group="' + group + '"][data-filter-value="all"]');
        if (allChip) allChip.classList.remove('active');
        if (group === 'price') {
          qsa('.aur-filter-chip[data-filter-group="price"]').forEach(function(c) { c.classList.remove('active'); });
        }
        chip.classList.toggle('active');
      }

      syncSidebarFromChips(group);
      updateActiveTagsUI();
      navigateWithFilters();
    });
  });

  /* ─────────────────────────────────────
     SIDEBAR OPTION TOGGLE
  ───────────────────────────────────── */
  qsa('.aur-sidebar-option').forEach(function(opt) {
    if (opt.getAttribute('onclick') && opt.getAttribute('onclick').includes('window.location')) return;

    opt.addEventListener('click', function(e) {
      e.preventDefault();
      var group = opt.dataset.filterGroup;
      var value = opt.dataset.filterValue;
      if (!group || !value) return;

      if (value === 'all') {
        qsa('.aur-sidebar-option[data-filter-group="' + group + '"]').forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
      } else {
        var allOpt = qs('.aur-sidebar-option[data-filter-group="' + group + '"][data-filter-value="all"]');
        if (allOpt) allOpt.classList.remove('active');
        if (group === 'price') {
          qsa('.aur-sidebar-option[data-filter-group="price"]').forEach(function(o) { o.classList.remove('active'); });
        }
        opt.classList.toggle('active');
      }

      syncChipsFromSidebar(group);
      updateActiveTagsUI();
      navigateWithFilters();
    });
  });

  function deleteParamValue(params, name, value) {
    var kept = params.getAll(name).filter(function(currentValue) {
      return currentValue !== value;
    });
    params.delete(name);
    kept.forEach(function(currentValue) {
      params.append(name, currentValue);
    });
  }

  function getCollectionBaseUrl() {
    var sectionRoot = qs('[data-collection-base-url]');
    return sectionRoot && sectionRoot.dataset.collectionBaseUrl
      ? sectionRoot.dataset.collectionBaseUrl
      : window.location.pathname;
  }

  function hasCollectionBaseUrl() {
    return !!qs('[data-collection-base-url]');
  }

  function normalizeTagHandle(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function optionUsesTagPath(option) {
    // Always route filters through Shopify's modern query-param scheme
    // (e.g. ?filter.p.tag=Twist). The legacy collection-tag path
    // (/collections/rings/twist) does not apply Search & Discovery filters,
    // which previously made Style/Availability/Gemstone selections do nothing.
    return false;
  }

  function getActiveTagHandlesFromLocation() {
    var handles = [];
    var basePath = getCollectionBaseUrl().replace(/\/$/, '');
    var currentPath = window.location.pathname.replace(/\/$/, '');
    var tagPath = currentPath.indexOf(basePath + '/') === 0
      ? currentPath.slice(basePath.length + 1)
      : '';

    if (tagPath) {
      tagPath.split('+').forEach(function(handle) {
        if (handle) handles.push(decodeURIComponent(handle));
      });
    }

    new URLSearchParams(window.location.search).getAll('filter.p.tag').forEach(function(value) {
      var handle = normalizeTagHandle(value);
      if (handle) handles.push(handle);
    });

    return handles.filter(function(handle, index) {
      return handle && handles.indexOf(handle) === index;
    });
  }

  function buildTagSectionUrl(tags, page, groups) {
    var params = new URLSearchParams(window.location.search);
    var selected = [].concat.apply([], Object.values(groups));
    var kept = params.getAll('filter.p.tag').filter(function(value) {
      return selected.indexOf(value) === -1;
    });
    params.delete('filter.p.tag');
    kept.concat(tags).forEach(function(value) { params.append('filter.p.tag', value); });
    params.delete('page');
    params.set('section_id', getSectionId());
    if (page && page > 1) params.set('page', String(page));

    return getCollectionBaseUrl() + '?' + params.toString();
  }

  function navigateRemovingTagValue(value) {
    var removeHandle = normalizeTagHandle(value);
    if (!removeHandle) return;

    var remainingHandles = getActiveTagHandlesFromLocation().filter(function(handle) {
      return normalizeTagHandle(handle) !== removeHandle;
    });
    var params = new URLSearchParams(window.location.search);
    var keptQueryTags = params.getAll('filter.p.tag').filter(function(tagValue) {
      return normalizeTagHandle(tagValue) !== removeHandle;
    });

    params.delete('filter.p.tag');
    keptQueryTags.forEach(function(tagValue) {
      params.append('filter.p.tag', tagValue);
    });
    params.delete('page');

    var search = params.toString();
    window.location.href = getCollectionBaseUrl()
      + (remainingHandles.length ? '/' + remainingHandles.join('+') : '')
      + (search ? '?' + search : '');
  }

  function navigateWithNativeOptionState(activeOptions) {
    var params = new URLSearchParams(window.location.search);
    var usedParams = {};
    var tagValues = [];

    qsa('.aur-native-filter-option[data-filter-param], .aur-fp-item[data-filter-param]').forEach(function(option) {
      var paramName = option.dataset.filterParam;
      if (paramName) usedParams[paramName] = true;
    });

    Object.keys(usedParams).forEach(function(paramName) {
      params.delete(paramName);
    });

    activeOptions.forEach(function(option) {
      if (!option || !option.dataset) return;
      var paramName = option.dataset.filterParam;
      var value = option.dataset.filterValue;
      if (!paramName || !value) return;

      if (optionUsesTagPath(option)) {
        tagValues.push(value);
      } else {
        params.append(paramName, value);
      }
    });

    params.delete('page');
    var tagPath = tagValues
      .map(normalizeTagHandle)
      .filter(Boolean)
      .join('+');
    var baseUrl = getCollectionBaseUrl();
    var search = params.toString();
    window.location.href = baseUrl + (tagPath ? '/' + tagPath : '') + (search ? '?' + search : '');
  }

  function bindNativeFilterOption(opt) {
    if (!opt || opt.dataset.aurBound === 'true') return;
    opt.dataset.aurBound = 'true';
    opt.addEventListener('click', function(event) {
      event.preventDefault();
      opt.classList.toggle('active');
      var checkbox = opt.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = opt.classList.contains('active');
      navigateWithNativeOptionState(qsa('.aur-native-filter-option.active'));
    });
  }

  function bindActiveTagRemoveButtons(scope) {
    qsa('.aur-active-tag button[data-remove-tag]', scope || document).forEach(function(button) {
      if (button.dataset.aurRemoveBound === 'true') return;
      button.dataset.aurRemoveBound = 'true';
      button.addEventListener('click', function(event) {
        event.preventDefault();
        navigateRemovingTagValue(button.dataset.removeTag);
      });
    });
  }

  function bindMobileNativeFilterButton(btn) {
    if (!btn || btn.dataset.aurMobileBound === 'true') return;
    btn.dataset.aurMobileBound = 'true';
    btn.addEventListener('click', function() {
      btn.classList.toggle('active');
    });
  }

  function bindMobileFilterAccordionHeader(header) {
    if (!header || header.dataset.aurAccordionBound === 'true') return;
    header.dataset.aurAccordionBound = 'true';
    header.addEventListener('click', function() {
      var section = header.parentElement;
      var isOpen  = section.classList.contains('open');
      var body    = section.querySelector('.aur-fp-body');

      qsa('.aur-fp-section.open').forEach(function(s) {
        s.classList.remove('open');
        var b = s.querySelector('.aur-fp-body');
        if (b) b.style.display = 'none';
        var h = s.querySelector('.aur-fp-header');
        if (h) h.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen && body) {
        section.classList.add('open');
        body.style.display = 'block';
        header.setAttribute('aria-expanded', 'true');
      }
    });
  }

  qsa('.aur-native-filter-option').forEach(function(opt) {
    bindNativeFilterOption(opt);
  });

  function normalizeFilterGroupTitle(title) {
    return String(title || '')
      .replace(/[•·]/g, '')
      .trim()
      .toLowerCase();
  }

  function isStableFilterGroup(title) {
    var normalized = normalizeFilterGroupTitle(title);
    return normalized === 'style' || normalized === 'availability' || normalized === 'gemstone';
  }

  function filterOptionKey(option) {
    if (!option || !option.dataset) return '';
    return (option.dataset.filterParam || '') + '::' + (option.dataset.filterValue || '');
  }

  function locationHasFilterOption(option) {
    if (!option || !option.dataset) return false;
    var paramName = option.dataset.filterParam;
    var value = option.dataset.filterValue;
    if (!paramName || !value) return false;

    if (optionUsesTagPath(option)) {
      var activeTagHandles = window.location.pathname.split('/').pop().split('+');
      return activeTagHandles.indexOf(normalizeTagHandle(value)) !== -1;
    }

    return new URLSearchParams(window.location.search).getAll(paramName).indexOf(value) !== -1;
  }

  function syncClonedFilterOption(clone, existingOption) {
    var active = existingOption
      ? existingOption.classList.contains('active')
      : locationHasFilterOption(clone);
    clone.classList.toggle('active', active);
    var checkbox = clone.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.checked = active;
    delete clone.dataset.aurBound;
    delete clone.dataset.aurMobileBound;
  }

  function getSidebarGroupTitle(group) {
    var title = qs('.aur-sidebar-title', group);
    return title ? title.textContent : '';
  }

  function getMobileGroupTitle(section) {
    var title = qs('.aur-fp-title', section);
    return title ? title.textContent : '';
  }

  function mergeDesktopFilterChoices(sourceDoc) {
    var sidebar = qs('#aur-filter-sidebar');
    var sourceSidebar = qs('#aur-filter-sidebar', sourceDoc);
    if (!sidebar || !sourceSidebar) return;

    var currentGroups = {};
    qsa('.aur-sidebar-group', sidebar).forEach(function(group) {
      var title = normalizeFilterGroupTitle(getSidebarGroupTitle(group));
      if (title) currentGroups[title] = group;
    });

    qsa('.aur-sidebar-group', sourceSidebar).forEach(function(sourceGroup) {
      var title = normalizeFilterGroupTitle(getSidebarGroupTitle(sourceGroup));
      if (!isStableFilterGroup(title)) return;

      var currentGroup = currentGroups[title];
      if (!currentGroup) {
        var groupClone = sourceGroup.cloneNode(true);
        qsa('.aur-native-filter-option', groupClone).forEach(function(option) {
          syncClonedFilterOption(option, null);
          bindNativeFilterOption(option);
        });
        sidebar.appendChild(groupClone);
        currentGroups[title] = groupClone;
        return;
      }

      var currentList = qs('.aur-sidebar-options', currentGroup);
      if (!currentList) return;

      var currentOptions = {};
      qsa('.aur-native-filter-option', currentGroup).forEach(function(option) {
        currentOptions[filterOptionKey(option)] = option;
      });

      qsa('.aur-native-filter-option', sourceGroup).forEach(function(sourceOption) {
        var key = filterOptionKey(sourceOption);
        if (!key || currentOptions[key]) return;

        var clone = sourceOption.cloneNode(true);
        syncClonedFilterOption(clone, null);
        bindNativeFilterOption(clone);
        currentList.appendChild(clone);
      });

      if (qsa('.aur-native-filter-option', currentList).length > 10) {
        currentList.classList.add('aur-sidebar-options--scroll');
      }
    });
  }

  function mergeMobileFilterChoices(sourceDoc) {
    var panelBody = qs('#aur-filter-panel-mobile .aur-filter-panel-body');
    var sourcePanelBody = qs('#aur-filter-panel-mobile .aur-filter-panel-body', sourceDoc);
    if (!panelBody || !sourcePanelBody) return;

    var currentSections = {};
    qsa('.aur-fp-section', panelBody).forEach(function(section) {
      var title = normalizeFilterGroupTitle(getMobileGroupTitle(section));
      if (title) currentSections[title] = section;
    });

    qsa('.aur-fp-section', sourcePanelBody).forEach(function(sourceSection) {
      var title = normalizeFilterGroupTitle(getMobileGroupTitle(sourceSection));
      if (!isStableFilterGroup(title)) return;

      var currentSection = currentSections[title];
      if (!currentSection) {
        var sectionClone = sourceSection.cloneNode(true);
        var headerClone = qs('.aur-fp-header', sectionClone);
        if (headerClone) {
          delete headerClone.dataset.aurAccordionBound;
          bindMobileFilterAccordionHeader(headerClone);
        }
        qsa('.aur-fp-item[data-filter-param]', sectionClone).forEach(function(button) {
          syncClonedFilterOption(button, null);
          bindMobileNativeFilterButton(button);
        });
        panelBody.appendChild(sectionClone);
        currentSections[title] = sectionClone;
        return;
      }

      var currentList = qs('.aur-fp-list', currentSection);
      if (!currentList) return;

      var currentOptions = {};
      qsa('.aur-fp-item[data-filter-param]', currentSection).forEach(function(button) {
        currentOptions[filterOptionKey(button)] = button;
      });

      qsa('.aur-fp-item[data-filter-param]', sourceSection).forEach(function(sourceButton) {
        var key = filterOptionKey(sourceButton);
        if (!key || currentOptions[key]) return;

        var clone = sourceButton.cloneNode(true);
        syncClonedFilterOption(clone, null);
        bindMobileNativeFilterButton(clone);
        currentList.appendChild(clone);
      });

      if (qsa('.aur-fp-item[data-filter-param]', currentList).length > 10) {
        currentList.classList.add('aur-fp-list--scroll');
      }
    });
  }

  function getOptionGroupMap(sourceDoc) {
    var optionGroups = {};

    qsa('#aur-filter-sidebar .aur-sidebar-group', sourceDoc).forEach(function(group) {
      var title = normalizeFilterGroupTitle(getSidebarGroupTitle(group));
      if (!isStableFilterGroup(title)) return;

      qsa('.aur-native-filter-option[data-filter-param="filter.p.tag"]', group).forEach(function(option) {
        var value = option.dataset.filterValue;
        var handle = normalizeTagHandle(value);
        if (!handle) return;

        optionGroups[handle] = {
          group: title,
          value: value,
          handle: handle
        };
      });
    });

    return optionGroups;
  }

  function getSelectedTagGroups(sourceDoc) {
    var optionGroups = getOptionGroupMap(sourceDoc);
    var groups = {};

    getActiveTagHandlesFromLocation().forEach(function(handle) {
      var option = optionGroups[handle];
      if (!option) return;
      if (!groups[option.group]) groups[option.group] = [];
      groups[option.group].push(option.value);
    });

    return groups;
  }

  function hasMultiSelectTagGroup(groups) {
    return Object.keys(groups).some(function(groupName) {
      return groups[groupName].length > 1;
    });
  }

  function buildTagGroupCombinations(groups) {
    var groupNames = Object.keys(groups).filter(function(groupName) {
      return groups[groupName].length;
    });
    var combinations = [[]];

    groupNames.forEach(function(groupName) {
      var nextCombinations = [];
      groups[groupName].forEach(function(handle) {
        combinations.forEach(function(combo) {
          nextCombinations.push(combo.concat(handle));
        });
      });
      combinations = nextCombinations;
    });

    return combinations;
  }

  function getProductCardKey(card) {
    var wishlistButton = qs('[data-product-id]', card);
    var productLink = qs('a[href*="/products/"]', card);
    return wishlistButton && wishlistButton.dataset.productId
      ? wishlistButton.dataset.productId
      : productLink && productLink.getAttribute('href')
        ? productLink.getAttribute('href').split('?')[0]
        : card.textContent.trim();
  }

  function updateCollectionCount(count) {
    var meta = qs('.aur-collection-meta');
    if (!meta) return;
    var text = meta.textContent || '';
    var suffixMatch = text.match(/\s+·\s+[\s\S]*$/);
    meta.textContent = count + ' piece' + (count === 1 ? '' : 's') + (suffixMatch ? suffixMatch[0] : '');
  }

  function renderMergedProductCards(cards) {
    var grid = qs('#aur-product-grid');
    if (!grid) return;

    grid.innerHTML = '';
    if (cards.length) {
      cards.forEach(function(card) {
        grid.appendChild(card);
      });
    } else {
      var noResults = document.createElement('p');
      noResults.className = 'aur-no-results visible';
      noResults.textContent = 'No products found matching your filters.';
      grid.appendChild(noResults);
    }

    var loadMoreWrap = qs('.aur-load-more-wrap');
    if (loadMoreWrap) loadMoreWrap.remove();

    updateCollectionCount(cards.length);
    grid.classList.remove('is-searching');
    refreshCardEnhancements(grid);
  }

  function fetchAllCardsForTagCombination(tags, groups) {
    var cards = [];
    var maxPages = 80;

    function fetchPage(page) {
      return fetch(buildTagSectionUrl(tags, page, groups))
        .then(function(response) {
          if (!response.ok) throw new Error('Grouped filter fetch failed: ' + response.status);
          return response.text();
        })
        .then(parseSectionHTML)
        .then(function(doc) {
          cards = cards.concat(qsa('.aur-product-card', doc).map(function(card) {
            return card.cloneNode(true);
          }));

          if (doc.querySelector('#aur-load-more-sentinel') && page < maxPages) {
            return fetchPage(page + 1);
          }

          return cards;
        });
    }

    return fetchPage(1);
  }

  function renderGroupedTagResults(sourceDoc) {
    var selectedGroups = getSelectedTagGroups(sourceDoc);
    if (!hasMultiSelectTagGroup(selectedGroups)) return;

    var grid = qs('#aur-product-grid');
    if (grid) grid.classList.add('is-searching');

    var seenProducts = {};
    var mergedCards = [];
    var combinations = buildTagGroupCombinations(selectedGroups);

    Promise.all(combinations.map(function(tags) { return fetchAllCardsForTagCombination(tags, selectedGroups); }))
      .then(function(results) {
        results.forEach(function(cards) {
          cards.forEach(function(card) {
            var key = getProductCardKey(card);
            if (!key || seenProducts[key]) return;
            seenProducts[key] = true;
            mergedCards.push(card);
          });
        });

        renderMergedProductCards(mergedCards);
      })
      .catch(function(error) {
        if (grid) grid.classList.remove('is-searching');
        console.warn('[Aurore] Grouped tag results unavailable:', error);
      });
  }

  function refreshStyleCounts(sourceDoc) {
    var styleValues = new Set();
    qsa('#aur-filter-sidebar .aur-sidebar-group', sourceDoc).forEach(function(group) {
      if (normalizeFilterGroupTitle(getSidebarGroupTitle(group)) !== 'style') return;
      qsa('[data-filter-param="filter.p.tag"]', group).forEach(function(option) {
        styleValues.add(option.dataset.filterValue);
      });
    });
    var params = new URLSearchParams(window.location.search);
    var tags = params.getAll('filter.p.tag');
    if (!tags.some(function(tag) { return styleValues.has(tag); })) return;
    params.delete('filter.p.tag');
    params.delete('page');
    params.delete('sort_by');
    tags.forEach(function(tag) { if (!styleValues.has(tag)) params.append('filter.p.tag', tag); });
    function applyCounts(doc) {
      var counts = new Map();
      qsa('#aur-filter-sidebar .aur-native-filter-option', doc).forEach(function(option) {
        var count = qs('.aur-cb-count', option);
        if (count) counts.set(filterOptionKey(option), count.textContent.trim());
      });
      qsa('.aur-native-filter-option, .aur-fp-item[data-filter-param]').forEach(function(option) {
        var count = qs('.aur-cb-count', option);
        if (count && option.dataset.filterParam === 'filter.p.tag' && styleValues.has(option.dataset.filterValue)) {
          count.textContent = counts.get(filterOptionKey(option)) || '0';
        }
      });
    }
    if (!params.toString()) return applyCounts(sourceDoc);
    params.set('section_id', getSectionId());
    return fetch(getCollectionBaseUrl() + '?' + params.toString())
      .then(function(response) { if (!response.ok) throw new Error('Style count request failed'); return response.text(); })
      .then(parseSectionHTML).then(applyCounts);
  }

  function mergeFullFilterChoices() {
    if (!hasCollectionBaseUrl() || !window.fetch) return;

    var params = new URLSearchParams();
    params.set('section_id', getSectionId());
    fetch(getCollectionBaseUrl() + '?' + params.toString())
      .then(function(response) {
        if (!response.ok) throw new Error('Filter option fetch failed: ' + response.status);
        return response.text();
      })
      .then(function(html) {
        var sourceDoc = parseSectionHTML(html);
        mergeDesktopFilterChoices(sourceDoc);
        mergeMobileFilterChoices(sourceDoc);
        renderGroupedTagResults(sourceDoc);
        return refreshStyleCounts(sourceDoc);
      })
      .catch(function(error) {
        console.warn('[Aurore] Full filter choices unavailable:', error);
      });
  }

  /* ─────────────────────────────────────
     SYNC SIDEBAR ↔ CHIPS
  ───────────────────────────────────── */
  function syncChipsFromSidebar(group) {
    var active = [];
    qsa('.aur-sidebar-option.active[data-filter-group="' + group + '"]').forEach(function(o) {
      active.push(o.dataset.filterValue);
    });
    qsa('.aur-filter-chip[data-filter-group="' + group + '"]').forEach(function(c) {
      c.classList.toggle('active', active.includes(c.dataset.filterValue));
    });
  }

  function syncSidebarFromChips(group) {
    var active = [];
    qsa('.aur-filter-chip.active[data-filter-group="' + group + '"]').forEach(function(c) {
      active.push(c.dataset.filterValue);
    });
    qsa('.aur-sidebar-option[data-filter-group="' + group + '"]').forEach(function(o) {
      o.classList.toggle('active', active.includes(o.dataset.filterValue));
    });
  }

  function navigateWithFilters() {
    var url = buildFilterURL(getActiveFilters());
    window.location.href = url;
  }

  /* ─────────────────────────────────────
     ACTIVE FILTER TAGS UI
  ───────────────────────────────────── */
  function updateActiveTagsUI() {
    var container = qs('#aur-active-filters');
    if (!container) return;

    var jsTags = container.querySelectorAll('.aur-active-tag[data-js]');
    jsTags.forEach(function(t) { t.remove(); });

    qsa('.aur-filter-chip.active:not([data-filter-value="all"])').forEach(function(chip) {
      var group = chip.dataset.filterGroup;
      var value = chip.dataset.filterValue;
      var label = chip.dataset.filterLabel || chip.textContent.trim();
      if (group === 'category') return;

      var tag = document.createElement('div');
      tag.className = 'aur-active-tag';
      tag.setAttribute('data-js', '1');
      tag.setAttribute('role', 'listitem');
      tag.innerHTML = label + '<button aria-label="Remove ' + label + ' filter" data-group="' + group + '" data-value="' + value + '" data-remove-tag="' + value + '">✕</button>';

      tag.querySelector('button').addEventListener('click', function(e) {
        if (e.currentTarget.dataset.removeTag) {
          navigateRemovingTagValue(e.currentTarget.dataset.removeTag);
          return;
        }

        var grp = e.currentTarget.dataset.group;
        var val = e.currentTarget.dataset.value;

        qsa('.aur-filter-chip[data-filter-group="' + grp + '"][data-filter-value="' + val + '"]').forEach(function(c) {
          c.classList.remove('active');
        });
        qsa('.aur-sidebar-option[data-filter-group="' + grp + '"][data-filter-value="' + val + '"]').forEach(function(o) {
          o.classList.remove('active');
        });

        var anyActive = qsa('.aur-filter-chip.active[data-filter-group="' + grp + '"]:not([data-filter-value="all"])').length;
        if (!anyActive) {
          var allChip = qs('.aur-filter-chip[data-filter-group="' + grp + '"][data-filter-value="all"]');
          if (allChip) allChip.classList.add('active');
        }

        updateActiveTagsUI();
        navigateWithFilters();
      });

      container.appendChild(tag);
    });

    // Native filter options (Style / Availability / Gemstone / metafield filters)
    var seenNative = {};
    qsa('.aur-native-filter-option.active').forEach(function(option) {
      var param = option.dataset.filterParam;
      var value = option.dataset.filterValue;
      if (!param || !value) return;
      var key = param + '::' + value;
      if (seenNative[key]) return;
      seenNative[key] = true;

      var label = option.dataset.filterLabel || option.textContent.trim();

      var nativeTag = document.createElement('div');
      nativeTag.className = 'aur-active-tag';
      nativeTag.setAttribute('data-js', '1');
      nativeTag.setAttribute('role', 'listitem');
      nativeTag.textContent = label;

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.setAttribute('aria-label', 'Remove ' + label + ' filter');
      removeBtn.textContent = '✕';
      removeBtn.addEventListener('click', function() {
        qsa('.aur-native-filter-option').forEach(function(o) {
          if (o.dataset.filterParam === param && o.dataset.filterValue === value) {
            o.classList.remove('active');
            var cb = o.querySelector('input[type="checkbox"]');
            if (cb) cb.checked = false;
          }
        });
        navigateWithNativeOptionState(qsa('.aur-native-filter-option.active'));
      });

      nativeTag.appendChild(removeBtn);
      container.appendChild(nativeTag);
    });
  }

  /* ─────────────────────────────────────
     SORT SELECT
  ───────────────────────────────────── */
  var sortSelect = qs('#aur-sort-select');
  if (sortSelect) {
    var currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort) sortSelect.value = currentSort;

    sortSelect.addEventListener('change', function() {
      var params = new URLSearchParams(window.location.search);
      if (sortSelect.value === 'featured' || !sortSelect.value) {
        params.delete('sort_by');
      } else {
        params.set('sort_by', sortSelect.value);
      }
      params.delete('page');
      updateCollectionUrl(params, true);
      renderCollectionFromLocation();
    });
  }

  /* ─────────────────────────────────────
     PRICE RANGE
  ───────────────────────────────────── */
  var priceDebounceTimer = null;
  function applyPriceRange() {
    var min = qs('#aur-price-min');
    var max = qs('#aur-price-max');
    if (!min && !max) return;

    var params = new URLSearchParams(window.location.search);
    var previousMin = params.get('filter.v.price.gte') || '';
    var previousMax = params.get('filter.v.price.lte') || '';
    var nextMin = min && min.value ? min.value.trim() : '';
    var nextMax = max && max.value ? max.value.trim() : '';
    if (previousMin === nextMin && previousMax === nextMax) return;

    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    if (nextMin) params.set('filter.v.price.gte', nextMin);
    if (nextMax) params.set('filter.v.price.lte', nextMax);
    params.delete('page');
    window.location.search = params.toString();
  }

  qsa('#aur-price-min, #aur-price-max').forEach(function(input) {
    input.addEventListener('input', function() {
      clearTimeout(priceDebounceTimer);
      priceDebounceTimer = setTimeout(applyPriceRange, 700);
    });

    input.addEventListener('change', function() {
      clearTimeout(priceDebounceTimer);
      applyPriceRange();
    });

    input.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        clearTimeout(priceDebounceTimer);
        applyPriceRange();
      }
    });
  });

  var priceApplyBtn = qs('#aur-price-apply');
  if (priceApplyBtn) {
    priceApplyBtn.addEventListener('click', function() {
      var params = new URLSearchParams(window.location.search);
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      var min = qs('#aur-price-min');
      var max = qs('#aur-price-max');
      if (min && min.value) params.set('filter.v.price.gte', min.value.trim());
      if (max && max.value) params.set('filter.v.price.lte', max.value.trim());
      params.delete('page');
      window.location.search = params.toString();
    });
  }

  /* ─────────────────────────────────────
     COLLECTION SEARCH — full filtered result set
  ───────────────────────────────────── */
  var collectionSearchForm = qs('#aur-collection-search-form');
  var collectionSearchInput = qs('#aur-collection-search-input');
  var searchDebounceTimer = null;
  var collectionRenderRequest = 0;
  var collectionAbortController = null;
  var sectionHTMLCache = new Map();
  var collectionSearchCache = new Map();
  var SEARCH_DEBOUNCE_MS = 600;
  var MIN_SEARCH_LENGTH = 2;

  function getSectionId() {
    var sectionEl = qs('[data-section-id]');
    return sectionEl ? sectionEl.dataset.sectionId : 'main-collection-product-grid';
  }

  function updateCollectionUrl(params, push) {
    var search = params.toString();
    var nextUrl = window.location.pathname + (search ? '?' + search : '');
    if (push) {
      window.history.pushState({ searchParams: search }, '', nextUrl);
    } else {
      window.history.replaceState({ searchParams: search }, '', nextUrl);
    }
  }

  function buildSectionUrl(params, page, includeSearchQuery) {
    var fetchParams = new URLSearchParams(params.toString());
    if (!includeSearchQuery) fetchParams.delete('q');
    fetchParams.set('section_id', getSectionId());
    fetchParams.set('page', String(page || 1));
    return window.location.pathname + '?' + fetchParams.toString();
  }

  function parseSectionHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function isAbortError(error) {
    return error && error.name === 'AbortError';
  }

  function currentSearchQuery() {
    return (new URLSearchParams(window.location.search).get('q') || '').trim();
  }

  function ensureSearchStatus() {
    var activeFilters = qs('#aur-active-filters');
    if (!activeFilters) return null;
    var status = qs('#aur-search-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'aur-search-status';
      status.className = 'aur-search-status';
      activeFilters.insertAdjacentElement('afterend', status);
    }
    return status;
  }

  function removeSearchStatus() {
    var status = qs('#aur-search-status');
    if (status) status.remove();
  }

  function cardMatchesQuery(card, query) {
    var needle = query.toLowerCase();
    if (!needle) return true;
    var haystack = [
      card.textContent || '',
      card.getAttribute('aria-label') || '',
      card.getAttribute('href') || ''
    ].join(' ').toLowerCase();
    return needle.split(/\s+/).every(function(term) {
      return haystack.indexOf(term) !== -1;
    });
  }

  function refreshCardEnhancements(scope) {
    bindWishlist(scope || document);
    bindVariantSwatches(scope || document);
    if (window.jdgm && typeof window.jdgm.customWidgetsLoader === 'function') {
      window.jdgm.customWidgetsLoader();
    }
    pruneEmptyReviewBadges(scope || document);
    window.setTimeout(function() { pruneEmptyReviewBadges(scope || document); }, 400);
  }

  function pruneEmptyReviewBadges(scope) {
    qsa('.aur-card-jdgm', scope || document).forEach(function(rating) {
      var badge = qs('.jdgm-prev-badge', rating) || rating;
      var text = (badge.textContent || rating.textContent || '').trim();
      var countAttr = badge.getAttribute('data-number-of-reviews') || rating.getAttribute('data-number-of-reviews');
      var explicitZero = countAttr !== null && String(countAttr) !== '' && parseInt(countAttr, 10) <= 0;
      if (explicitZero || /no\s+reviews/i.test(text)) {
        rating.hidden = true;
      }
    });
  }

  function replaceGridFromDocument(doc) {
    var sourceGrid = doc.querySelector('#aur-product-grid');
    var targetGrid = qs('#aur-product-grid');
    if (sourceGrid && targetGrid) targetGrid.innerHTML = sourceGrid.innerHTML;

    var sourceLoadMore = doc.querySelector('.aur-load-more-wrap');
    var targetLoadMore = qs('.aur-load-more-wrap');
    if (sourceLoadMore && targetLoadMore) {
      targetLoadMore.replaceWith(sourceLoadMore);
    } else if (sourceLoadMore && targetGrid) {
      targetGrid.insertAdjacentElement('afterend', sourceLoadMore);
    } else if (targetLoadMore) {
      targetLoadMore.remove();
    }

    refreshCardEnhancements(targetGrid || document);
    bindLoadMore();
  }

  function createCollectionRequest() {
    if (collectionAbortController) collectionAbortController.abort();
    collectionAbortController = window.AbortController ? new AbortController() : null;
    return collectionAbortController ? collectionAbortController.signal : null;
  }

  function cancelActiveCollectionRequest() {
    collectionRenderRequest += 1;
    if (collectionAbortController) collectionAbortController.abort();
    var grid = qs('#aur-product-grid');
    if (grid) grid.classList.remove('is-searching');
  }

  function fetchSectionDocument(params, page, includeSearchQuery, signal) {
    var url = buildSectionUrl(params, page, includeSearchQuery);
    if (sectionHTMLCache.has(url)) {
      return Promise.resolve(parseSectionHTML(sectionHTMLCache.get(url)));
    }

    return fetch(url, { signal: signal })
      .then(function(response) {
        if (!response.ok) throw new Error('Section fetch failed: ' + response.status);
        return response.text();
      })
      .then(function(html) {
        sectionHTMLCache.set(url, html);
        return html;
      })
      .then(parseSectionHTML);
  }

  function buildSearchCacheKey(params, query) {
    var cacheParams = new URLSearchParams(params.toString());
    cacheParams.delete('page');
    cacheParams.set('q', query);
    return window.location.pathname + '?' + cacheParams.toString();
  }

  function renderCardsToGrid(cards, query, status) {
    var targetGrid = qs('#aur-product-grid');
    if (!targetGrid) return;

    targetGrid.innerHTML = '';
    if (cards.length) {
      cards.forEach(function(card) { targetGrid.appendChild(card.cloneNode(true)); });
      if (status) status.textContent = cards.length + ' matching product' + (cards.length === 1 ? '' : 's');
    } else {
      var noResults = document.createElement('p');
      noResults.className = 'aur-no-results visible';
      noResults.textContent = 'No matching products.';
      targetGrid.appendChild(noResults);
      if (status) status.textContent = 'No matching products';
    }

    var loadMoreWrap = qs('.aur-load-more-wrap');
    if (loadMoreWrap) loadMoreWrap.remove();
    targetGrid.classList.remove('is-searching');
    refreshCardEnhancements(targetGrid);
  }

  function appendSearchMatches(cards, targetGrid) {
    var fragment = document.createDocumentFragment();
    cards.forEach(function(card) {
      fragment.appendChild(card.cloneNode(true));
    });
    targetGrid.appendChild(fragment);
    bindWishlist(targetGrid);
    bindVariantSwatches(targetGrid);
  }

  function renderSearchResults(params, query, requestId, signal) {
    var grid = qs('#aur-product-grid');
    var status = ensureSearchStatus();
    var cacheKey = buildSearchCacheKey(params, query);

    if (collectionSearchCache.has(cacheKey)) {
      renderCardsToGrid(collectionSearchCache.get(cacheKey), query, status);
      return;
    }

    if (grid) grid.classList.add('is-searching');
    if (status) status.textContent = 'Searching...';

    var targetGrid = qs('#aur-product-grid');
    var loadMoreWrap = qs('.aur-load-more-wrap');
    var matchedCards = [];
    var renderedCount = 0;
    var maxPages = 80;

    if (!targetGrid) return;
    targetGrid.innerHTML = '';
    if (loadMoreWrap) loadMoreWrap.remove();

    function finishSearch() {
      if (requestId !== collectionRenderRequest) return;
      collectionSearchCache.set(cacheKey, matchedCards.map(function(card) { return card.cloneNode(true); }));
      targetGrid.classList.remove('is-searching');

      if (!renderedCount) {
        var noResults = document.createElement('p');
        noResults.className = 'aur-no-results visible';
        noResults.textContent = 'No matching products.';
        targetGrid.appendChild(noResults);
        if (status) status.textContent = 'No matching products';
      } else if (status) {
        status.textContent = renderedCount + ' matching product' + (renderedCount === 1 ? '' : 's');
      }

      refreshCardEnhancements(targetGrid);
    }

    function fetchPage(page) {
      if (requestId !== collectionRenderRequest || (signal && signal.aborted)) return;

      fetchSectionDocument(params, page, false, signal)
        .then(function(doc) {
          if (requestId !== collectionRenderRequest || (signal && signal.aborted)) return;

          var matches = qsa('.aur-product-card', doc).filter(function(card) {
            return cardMatchesQuery(card, query);
          });

          if (matches.length) {
            matchedCards = matchedCards.concat(matches);
            renderedCount += matches.length;
            appendSearchMatches(matches, targetGrid);
            if (status) status.textContent = 'Showing ' + renderedCount + ' matching product' + (renderedCount === 1 ? '' : 's') + '...';
          }

        if (doc.querySelector('#aur-load-more-sentinel') && page < maxPages) {
            fetchPage(page + 1);
          } else {
            finishSearch();
          }
        })
        .catch(function(error) {
          if (isAbortError(error) || requestId !== collectionRenderRequest) return;
          console.error('[Aurore] Collection search error:', error);
          targetGrid.classList.remove('is-searching');
          if (status) status.textContent = 'Search unavailable. Please try again.';
        });
    }

    fetchPage(1);
  }

  function renderCollectionFromLocation() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    var query = (params.get('q') || '').trim();
    var requestId = ++collectionRenderRequest;
    var signal = createCollectionRequest();

    if (collectionSearchInput) collectionSearchInput.value = query;

    if (query) {
      renderSearchResults(params, query, requestId, signal);
      return;
    }

    removeSearchStatus();
    var grid = qs('#aur-product-grid');
    if (grid) grid.classList.add('is-searching');
    fetchSectionDocument(params, 1, true, signal)
      .then(function(doc) {
        if (requestId !== collectionRenderRequest) return;
        replaceGridFromDocument(doc);
        var currentGrid = qs('#aur-product-grid');
        if (currentGrid) currentGrid.classList.remove('is-searching');
      })
      .catch(function(error) {
        if (isAbortError(error) || requestId !== collectionRenderRequest) return;
        console.error('[Aurore] Collection refresh error:', error);
        var currentGrid = qs('#aur-product-grid');
        if (currentGrid) currentGrid.classList.remove('is-searching');
      });
  }

  function submitCollectionSearch(push) {
    if (!collectionSearchInput) return;
    var params = new URLSearchParams(window.location.search);
    var query = collectionSearchInput.value.trim();

    if (query && query.length < MIN_SEARCH_LENGTH) {
      cancelActiveCollectionRequest();
      removeSearchStatus();
      return;
    }

    var previousQuery = (params.get('q') || '').trim();
    if (query === previousQuery) return;

    if (query) {
      params.set('q', query);
    } else {
      params.delete('q');
    }

    if (query !== previousQuery) params.delete('page');
    updateCollectionUrl(params, push !== false);
    renderCollectionFromLocation();
  }

  if (collectionSearchForm && collectionSearchInput) {
    collectionSearchForm.addEventListener('submit', function(event) {
      event.preventDefault();
      submitCollectionSearch(true);
    });

    collectionSearchInput.addEventListener('input', function() {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function() {
        submitCollectionSearch(true);
      }, SEARCH_DEBOUNCE_MS);
    });
  }

  window.addEventListener('popstate', renderCollectionFromLocation);

  /* ─────────────────────────────────────
     VARIANT SWATCHES — card interaction
  ───────────────────────────────────── */
  function bindVariantSwatches(scope) {
    qsa('.aur-variant-options', scope).forEach(function(optionsEl) {
      var labelEl = optionsEl.closest('.aur-variant-group').querySelector('.aur-variant-selected');
      var swatches = optionsEl.querySelectorAll('.aur-variant-swatch');

      swatches.forEach(function(swatch) {
        if (swatch.dataset.bound) return;
        swatch.dataset.bound = '1';

        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          swatches.forEach(function(s) {
            s.classList.remove('active');
            s.setAttribute('aria-checked', 'false');
          });

          swatch.classList.add('active');
          swatch.setAttribute('aria-checked', 'true');

          if (labelEl) {
            labelEl.textContent = swatch.dataset.label || swatch.getAttribute('title') || '';
          }

          /* Optionally update card material text */
          var card = swatch.closest('.aur-product-card');
          if (card) {
            var materialEl = card.querySelector('.aur-card-material');
            if (materialEl && swatch.dataset.label) {
              materialEl.textContent = swatch.dataset.label;
            }
          }
        });

        /* Keyboard */
        swatch.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            swatch.click();
          }
        });
      });
    });
  }
  bindVariantSwatches(document);

  /* ─────────────────────────────────────
     BAR ACTIVE FILTER PILLS (sort/price removal)
  ───────────────────────────────────── */
  qsa('.aur-bar-pill[data-remove-param]').forEach(function(pill) {
    pill.addEventListener('click', function() {
      var params = new URLSearchParams(window.location.search);
      pill.dataset.removeParam.split(',').forEach(function(p) { params.delete(p.trim()); });
      params.delete('page');
      window.location.search = params.toString();
    });
  });

  /* ─────────────────────────────────────
     MOBILE FILTER PANEL
  ───────────────────────────────────── */
  var filterToggle = qs('#aur-filter-toggle');
  var filterPanel  = qs('#aur-filter-panel-mobile');

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function() {
      filterPanel.style.display = 'flex';
      filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }

  qsa('.aur-filter-close').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (filterPanel) { filterPanel.style.display = 'none'; }
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });

  /* ── ACCORDION ── */
  qsa('.aur-fp-header').forEach(function(header) {
    bindMobileFilterAccordionHeader(header);
  });

  /* ── MOBILE PANEL — collect-then-apply ── */

  /* Sort: one-of-N, toggle active state only */
  qsa('.aur-fp-item[data-filter-group="sort"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      qsa('.aur-fp-item[data-filter-group="sort"]').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
    });
  });

  /* Native filter items: toggle individual active state */
  qsa('.aur-fp-item[data-filter-param]').forEach(function(btn) {
    bindMobileNativeFilterButton(btn);
  });

  mergeFullFilterChoices();

  /* Apply button: collect all active state and navigate once */
  var viewBtn = qs('#aur-view-btn');
  if (viewBtn) {
    viewBtn.addEventListener('click', function() {
      var params = new URLSearchParams(window.location.search);

      /* Sort */
      var activeSort = qs('.aur-fp-item[data-filter-group="sort"].active');
      if (activeSort) {
        var sortVal = activeSort.dataset.filterValue;
        if (sortVal && sortVal !== 'featured') {
          params.set('sort_by', sortVal);
        } else {
          params.delete('sort_by');
        }
      }

      /* Price range */
      var minIn = qs('#aur-fp-price-min');
      var maxIn = qs('#aur-fp-price-max');
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      if (minIn && minIn.value.trim()) params.set('filter.v.price.gte', minIn.value.trim());
      if (maxIn && maxIn.value.trim()) params.set('filter.v.price.lte', maxIn.value.trim());

      updateCollectionUrl(params, false);
      navigateWithNativeOptionState(qsa('.aur-fp-item[data-filter-param].active'));
    });
  }

  bindActiveTagRemoveButtons(document);

  /* Panel pills — data-remove-param buttons */
  qsa('#aur-filter-panel-mobile .aur-fp-pill[data-remove-param]').forEach(function(pill) {
    pill.addEventListener('click', function() {
      var params = new URLSearchParams(window.location.search);
      pill.dataset.removeParam.split(',').forEach(function(p) { params.delete(p.trim()); });
      params.delete('page');
      window.location.search = params.toString();
    });
  });

  /* ─────────────────────────────────────
     WISHLIST
  ───────────────────────────────────── */
  function bindWishlist(scope) {
    qsa('.aur-card-wishlist', scope).forEach(function(btn) {
      if (btn.dataset.bound) return;
      if (btn.classList.contains('aur-wish-btn') && btn.dataset.productId) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        btn.classList.toggle('wished');
        btn.textContent = btn.classList.contains('wished') ? '♥' : '♡';
        btn.setAttribute('aria-label', btn.classList.contains('wished') ? 'Remove from wishlist' : 'Save to wishlist');
      });
    });
  }
  bindWishlist(document);

  /* ─────────────────────────────────────
     INFINITE SCROLL — fixed with section_id
  ───────────────────────────────────── */
  var loadMoreObserver = null;

  function bindLoadMore() {
    var loadMoreTrigger = qs('#aur-load-more-sentinel');
    if (!loadMoreTrigger || loadMoreTrigger.dataset.bound) return;
    loadMoreTrigger.dataset.bound = '1';

    function loadNextPage() {
      if (loadMoreTrigger.dataset.loading === 'true') return;
      var nextUrl = loadMoreTrigger.dataset.nextUrl;
      if (!nextUrl) return;

      var sectionEl = qs('[data-section-id]');
      var sectionId = sectionEl ? sectionEl.dataset.sectionId : 'main-collection-product-grid';

      loadMoreTrigger.dataset.loading = 'true';
      var countEl = qs('#aur-load-more-count');
      if (countEl) countEl.textContent = 'Loading more products...';

      var currentParams = new URLSearchParams(window.location.search);
      var nextParams    = new URLSearchParams(nextUrl.indexOf('?') > -1 ? nextUrl.split('?')[1] : '');
      var page = nextParams.get('page') || '2';
      currentParams.set('page', page);
      currentParams.set('section_id', sectionId);

      var fetchUrl = window.location.pathname + '?' + currentParams.toString();

      fetch(fetchUrl)
        .then(function(r) {
          if (!r.ok) throw new Error('Load more failed: ' + r.status);
          return r.text();
        })
        .then(function(html) {
          var parser   = new DOMParser();
          var doc      = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.aur-product-card');
          var grid     = qs('#aur-product-grid');

          if (!newCards.length) {
            var wrap = loadMoreTrigger.closest('.aur-load-more-wrap');
            if (wrap) wrap.style.display = 'none';
            return;
          }

          newCards.forEach(function(card) { grid.appendChild(card); });
          refreshCardEnhancements(grid);

          var shown = grid.querySelectorAll('.aur-product-card').length;
          var total = parseInt(loadMoreTrigger.dataset.total, 10) || shown;

          var fillEl  = qs('#aur-progress-fill');
          if (countEl) countEl.textContent = 'Showing ' + shown + ' of ' + total + ' products';
          if (fillEl)  fillEl.style.width  = Math.min(Math.round((shown / total) * 100), 100) + '%';

          if (shown >= total) {
            var wrapEl = loadMoreTrigger.closest('.aur-load-more-wrap');
            if (wrapEl) wrapEl.style.display = 'none';
          } else {
            currentParams.set('page', parseInt(page, 10) + 1);
            currentParams.delete('section_id');
            loadMoreTrigger.dataset.nextUrl = window.location.pathname + '?' + currentParams.toString();
            loadMoreTrigger.dataset.loading = 'false';
          }
        })
        .catch(function(err) {
          console.error('[Aurore] Load more error:', err);
          loadMoreTrigger.dataset.loading = 'false';
          if (countEl) countEl.textContent = 'Scroll to load more products';
        });
    }

    if ('IntersectionObserver' in window) {
      if (loadMoreObserver) loadMoreObserver.disconnect();
      loadMoreObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) loadNextPage();
        });
      }, { rootMargin: '600px 0px' });
      loadMoreObserver.observe(loadMoreTrigger);
    } else {
      window.addEventListener('scroll', function() {
        var rect = loadMoreTrigger.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) loadNextPage();
      }, { passive: true });
    }
  }

  /* ─────────────────────────────────────
     INIT
  ───────────────────────────────────── */
  syncUIFromURL();
  refreshCardEnhancements(document);
  bindLoadMore();
  if (currentSearchQuery() && !qs('[data-aurore-search-results]')) {
    renderCollectionFromLocation();
  }

})();
